export const useSignaturePlugin = (onSignatureClick: () => void) => {
  if (typeof window === "undefined") return;

  const tryRegister = () => {
    if ((window as any).tinymce?.PluginManager?.lookup?.signaturePlugin) return;
    if (!(window as any).tinymce) {
      setTimeout(tryRegister, 50);
      return;
    }
    (window as any).tinymce.PluginManager.add("signaturePlugin", function (editor: any) {
      editor.ui.registry.addButton("signatureButton", {
        text: "Signature",
        tooltip: "Insert Signature",
        onAction: function () {
          onSignatureClick();
        },
      });
    });
  };

  tryRegister();
};
